import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {getUserDetails} from "../RequestManager";
import {socket} from "../components/Socket";
import {Grid, Group, Image, Paper, Text, Badge, Stack, Modal} from "@mantine/core";
import CustomHeader from "../components/CustomHeader";
import PageLoading from "../components/PageLoading";

class Assignments extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            assignments: [],
            isLoading: true,
        }
    }
    componentDidMount() {
        this.getDetails();
        socket.on('success',this.handleSuccess);
        socket.on('failure',this.handleFailure);
    }
    componentWillUnmount() {
        socket.off('success');
        socket.off('failure');
    }
    handleSuccess = (data) =>{
        switch(data?.type){
            case 'UserAssignments':
                const {assignments,} = data;
                this.setState({assignments,isLoading: false});
                break;

        }
    }
    handleFailure = (data) =>{
        switch(data?.type){
            case 'UserAssignments':
                this.setState({alert: {message: data?.message,action: 'error'},isLoading: false});
                break;
        }
    }
    getDetails = () =>{
        socket.emit("UserAssignments",{mobile: this.props.mobile,productId: "Daily1Book"});
    }
    openAssignDetails = (bookId,id) =>{
        const {assignments} = this.state;
        if(id){
            this.props.navigation(`/assign-submit/${bookId}/${id}`)
        }else {
            const assign = assignments?.find(a => a.id === bookId)?.assignments || [];
            if(assign?.length > 1){
                this.setState({editDetails: {bookId,assignments: assign}});
            } else if(assign?.length > 0){
                this.props.navigation(`/assign-submit/${bookId}/${assign?.[0]?.id}`);
            }
        }
    }
    hideModal = () => this.setState({editDetails: undefined});

    render() {
        const {assignments,editDetails,isLoading} = this.state;
        return <div>
            <CustomHeader title={"Assignments"} showBackPress={true} />
            {isLoading ? <PageLoading />: <>
                <Modal opened={editDetails != undefined} onClose={this.hideModal} title={"Choose Assignment"}>
                    {editDetails?.assignments?.map(a =>{
                        return <Paper shadow={'md'} withBorder m={5} onClick={() => this.openAssignDetails(editDetails?.bookId, a?.id)}>
                            <Group px={10}>
                                <Text>{a?.title}</Text>
                            </Group>
                        </Paper>
                    })}
                </Modal>
                <Grid mt={50}>
                    {assignments?.map(a =>{
                        return <Grid.Col span={3}>
                            <Paper shadow={'md'} withBorder onClick={() => this.openAssignDetails(a?.id, undefined)}>
                                <Group>
                                    <Image src={a?.image} width={50} height={50}/>
                                    <Stack sx={{gap: 3}}>
                                        <Text>{a?.title}</Text>
                                        <Badge>Assignments: {a?.assignments?.length || 0}</Badge>
                                    </Stack>
                                </Group>
                            </Paper>
                        </Grid.Col>
                    })}
                </Grid></>}

        </div>
    }
}
export default function(props){
    const navigation = useNavigate();
    const {state} = useLocation();
    const user = getUserDetails();
    return <Assignments {...props} params={state} navigation={navigation} mobile={user?.mobile} user={user}  />
};
